import { Component, OnInit } from '@angular/core';
import { SelfService } from '../self-services.service.ts';
import { ConstantValues } from '../../bpg-common/models/bpg-constants';

import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { BpgCommonService } from 'src/app/bpg-common/services/bpg-common.service.js';

@Component({
  selector: 'app-bpg',
  templateUrl: './bpg.component.html',
  styleUrls: ['./bpg.component.css']
})
export class BpgComponent implements OnInit {
  landingDto: any;
  landingDtoPage: any;
  bpgName: string = null;
  bpgDesc: string = null;
  bpgData: any[] = [];
  editandSavebtn: boolean = false;
  savebtn: boolean = false;
  bpgId: string;
  alertSuccess: boolean;
  alertFailure: boolean;
  alertUpdate: boolean;
  bpgNameCheckOnEdit: string = "";
  tableresp: boolean;
  tableShow: boolean;
  numberOfElements: number;
  noDataFound: boolean;
  currentPage: number = 0;
  limit: number = ConstantValues.pageLimit;
  currentShowingElements: number = ConstantValues.pageLimit;
  searchKey: any;
  method: string;
  param: string;
  msg1: string;
  firstEdit = false;
  errorMessage ="";
  adminId:any = localStorage.getItem('adminId');
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  userId: any = this.loginDetails['userId'];
  timeOutError: boolean;
  timeoutErrorMessage : string = ConstantValues.timeoutErrorMessage;

  removeToolbar : any = {toolbar : 'Basic', uiColor: '#FFFFFF', basicEntities:false, fillEmptyBlocks:false, removeButtons:'Source,Save,NewPage,Preview,Print,Templates,Pasteas plain text,PastefromWord,Find,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,SelectionField,Button,ImageButton,HiddenField,Italic,Decrease,Increase,Block,Create Div Container,Text direction from left to right,Text direction from right to left,Set language,Link,Unlink,Image,Flash,Table,Horizontal,Smiley,Insert Special Character,Insert Page Break for Printing,IFrame,Formatting,Paragraph,Font,FontSize,TextColor,BackgroundColor,Maximize,ShowBlocks,About,forceSpellChecker,Cut,Copy,Paste,Undo,Redo,Anchor,Underline,Strike,Subscript,Superscript,Bold,RemoveFormat'};

  /**
   * @class BpgComponent
   * @constructor
   */
  constructor(private readonly bpgService: SelfService,
    private readonly bpgCommonService: BpgCommonService,
    private readonly router: Router,
  private readonly spinner : Ng4LoadingSpinnerService,
  private readonly environment : EnvironmentConfiguration) { }

  ngOnInit() {

    if(this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod'){
   if(localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined ){
      this.router.navigate(['/log-out']);
    }}
    localStorage.removeItem('searchedEventsCaledarItems');

    if(this.adminId !== '1')
    {
      this.router.navigate(['/site-home']);
    }
    this.logUserAction();
    this.spinner.show();
    this.savebtn = true;
    this.bpgId = '0';
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.landingDto = {
      "filter": { },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "",
      "uid": ""      
    }

    this.landingDtoPage = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": ConstantValues.pageLimit,
      "sortDirection": "ASC",
      "sortProperty": "bpgName",
      "uid": ""      
    }
    this.spinner.show();
    this.listBpg();

    if(window.innerWidth<767){
      this.tableresp = true;
    }else{
      this.tableresp = false;
    }
    //this.spinner.hide();
  }
  /** For submitting the bpg detail form
     * @class BpgComponent
     * @method onSubmit
     */
  public onSubmit() {
    this.clearAlerts();
    this.bpgName = this.bpgName.trim();
    if (this.editandSavebtn == true) {
      this.method = "save";
      this.param = '';
      this.msg1 = " Are you sure you want to update ? ";
      }
      else {
        this.method = "save";
        this.param = '';
        this.msg1 = " Are you sure you want to save ? ";
      }
}



  /** For editing the existing bpg details
   * @method editBpg
   */
  editBpg(data) {
    this.bpgName = data.bpgName;
    this.bpgNameCheckOnEdit = data.bpgName;
    this.bpgDesc = data.bpgDesc;
    this.bpgId = data.bpgId;
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.editandSavebtn = true;
    this.savebtn = false;
  }

  edit(data,i){
    this.clearAlerts(); 
    if(this.bpgName!=null || this.bpgDesc!=null ){
      this.firstEdit = true;
    }
    if(this.firstEdit == false){
      this.firstEdit = true;
      this.editBpg(data);
    }else{    
    document.getElementById('edit'+i).setAttribute('data-toggle','modal');
    document.getElementById('edit'+i).setAttribute('data-target','#myModal');
    this.method = "editBpg";
    this.param = data;
    this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
    }
  }

  /** For resetting the bpg form
  * @method resetBpg
  */
  resetBpg() {
    this.clearAlerts();
    this.method = "onResetClick";
    this.param = '';
    this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
  }

  onResetClick(){
    this.clearAlerts();
    this.bpgName = null;
    this.bpgDesc = "";
    this.bpgId = '0';
    this.searchKey= null;
    this.landingDtoPage.searchTerm = null;
    this.listBpg();
    this.editandSavebtn = false;
    this.savebtn = true;
    for(var i=0;i<this.bpgData.length;i++){
      document.getElementById('edit'+i).removeAttribute('data-toggle');
      document.getElementById('edit'+i).removeAttribute('data-target');
      }
      this.firstEdit = false;
  }

  /** For getting all the bpg details
  * @method listBpg
  */
  listBpg() {
    this.timeOutError = false;
    this.bpgService.getBpgListPage(this.landingDtoPage).subscribe(data => {
      this.bpgData = data.content;
      this.tableShow = true;
      this.numberOfElements = data.totalElements;
        if (this.bpgData.length == 0) {
          this.tableShow = false;
          this.noDataFound = true;
        } else {
          this.tableShow = true;
          this.noDataFound = false;
          setTimeout(function () {
            this.spinner.hide();
          }.bind(this), 2000);
        }

    }, err => {
      this.spinner.hide();
      console.log(JSON.stringify(err.value.message));
      if(err.value.statusText == ConstantValues.unknownError){
                  this.timeOutError = true;
                }
    })
  }

  /** For deleting the bpg detail
   * @method deleteBpg
   * @param bpgId
   */
  deleteBpg(data) {
    this.timeOutError = false;
    this.bpgService.deleteBpg(data.bpgId).subscribe(data => {
      this.listBpg();

    }, err => {
      this.spinner.hide();
      console.log(JSON.stringify(err.value.message));
      if(err.value.statusText == ConstantValues.unknownError){
                  this.timeOutError = true;
                }
    })
  }

/** For filtering data by current page 
   * @class BPGComponent
   * @method pageChanged
   * @params event
   */
  pageChanged(event) {
    this.clearAlerts();
    this.landingDtoPage.page = event - 1;
    this.currentPage = event;
    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
    this.listBpg();
  }

  /** For sorting the table through columns
   * @class BPGComponent
   * @method sortMe
   */

  public sortMe(sortingby) {
    this.clearAlerts();
    if (this.landingDtoPage.sortDirection == "ASC") {
      this.landingDtoPage.sortDirection = "DESC";
      document.getElementById(sortingby + "1").classList.add("fading");
      document.getElementById(sortingby + "2").classList.remove("fading");
    } else {
      this.landingDtoPage.sortDirection = "ASC";
      document.getElementById(sortingby + "2").classList.add("fading");
      document.getElementById(sortingby + "1").classList.remove("fading");
    }
    this.landingDtoPage.sortProperty = sortingby;
    this.listBpg();
  }

     /** For searching the table through keywords
   * @class BpgComponent
   * @method searchMe
   */
  searchMe() {
    this.clearAlerts();
   this.spinner.show();
    this.searchKey = (this.searchKey) ? this.searchKey : '';
    this.landingDtoPage.page = 0;
    this.landingDtoPage.searchTerm = this.searchKey;
    this.currentPage = 1;
    this.listBpg();
    this.spinner.hide();
  }

   /** For submitting the bpg detail form
     * @class BpgComponent
     * @method save
     */
    public save() {
      this.timeOutError = false;
      this.spinner.show();
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      let data = { "bpgId": this.bpgId, "bpgName": this.bpgName, "bpgDesc": this.bpgDesc, "createdBy": 1, "modifiedBy": 1 };
      this.bpgService.saveAllBpg(data).subscribe(data => {
        //for validating duplication of BPG Name
        if(data.message){  
          this.spinner.hide(); 
          this.errorMessage = data.message;
          this.alertFailure = true;
          return;
        }
  
    if(this.editandSavebtn == true){

      this.spinner.hide();
      this.alertFailure = false;
      this.alertUpdate=true;

    }else{
      this.spinner.hide();
    this.alertSuccess = true; 
    }
    this.listBpg();       
    //this.resetBpg();    
  }, err => {
    this.spinner.hide();
    console.log(JSON.stringify(err.value.message));
    if(err.value.statusText == ConstantValues.unknownError){
                this.timeOutError = true;
              }
  })
  }
  
  //to clear all the alert messages
  clearAlerts(){
    this.alertFailure = false;
    this.alertUpdate = false;
    this.alertSuccess = false;
  } 

  logUserAction() {
    const data = {
      userId : this.userId,
      categoryDescription : "SelfServices - BPG Screen"
    };
    this.bpgCommonService.logUserAction(data).subscribe(
      (_data) => {});
  }

}
